export const SET_KEYWORD = '@komigen/mobile-frontend/search/SET_KEYWORD';
export const CLEAR_KEYWORD = '@komigen/mobile-frontend/search/CLEAR_KEYWORD';
export const SET_PAGE = '@komigen/mobile-frontend/search/SET_PAGE';
export const SET_SCROLL_POSITION = '@komigen/mobile-frontend/search/SET_SCROLL_POSITION';
export const SET_GRAPHYTE_REMOTE_RESULTS = '@komigen/mobile-frontend/search/SET_GRAPHYTE_REMOTE_RESULTS';
export const SET_GRAPHYTE_CASINO_EXPLORE_RECOMMENDATIONS =
	'@komigen/mobile-frontend/search/SET_GRAPHYTE_CASINO_EXPLORE_RECOMMENDATIONS';
export const SET_GRAPHYTE_LIVE_CASINO_EXPLORE_RECOMMENDATIONS =
	'@komigen/mobile-frontend/search/SET_GRAPHYTE_LIVE_CASINO_EXPLORE_RECOMMENDATIONS';
